<template>
  <div class="reportforrepair">
    <div class="header">
      <div class="title">多渠道报事报修</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <img :src="reportforrepair1" alt="" />
        <img :src="reportforrepair2" alt="" />
        <img :src="reportforrepair3" alt="" />
      </div>
      <div class="right">
        <div class="item" v-for="item in reportforrepairList" :key="item.id">
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import reportforrepair1 from "../../../../assets/product/reportforrepair1.png";
import reportforrepair2 from "../../../../assets/product/reportforrepair2.png";
import reportforrepair3 from "../../../../assets/product/reportforrepair3.png";

export default {
  setup() {
    return reactive({
      reportforrepair1: reportforrepair1,
      reportforrepair2: reportforrepair2,
      reportforrepair3: reportforrepair3,
      reportforrepairList: [
        {
          id: 1,
          title: "业主线上报修",
          text: "业主发现问题，通过业主端APP、公众号、小程序等多种渠道提交申请，一键报修，省时省力。",
        },
        {
          id: 2,
          title: "员工内部下单",
          text: "内部员工通过员工专用APP提交申请，一键报事提单，方便快捷。",
        },
        {
          id: 3,
          title: "线上客服下单",
          text: "业主发现问题，可直接拨打客服热线，在线沟通，客服直接下单。",
        },
        {
          id: 4,
          title: "线下下单",
          text: "业主线下扫描二维码，当场提交申请，进行报事报修。",
        },
      ],
    });
  },
};
</script>

<style scoped>
.reportforrepair {
  width: 1180px;
  margin: 80px auto;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
}
.body .left img {
  width: 225px;
  margin-right: 30px;
}
.body .right {
  margin-left: 30px;
}

.body .right .item {
  margin-bottom: 40px;
}
.body .right .item .text {
  width: 385px;
  font-size: 14px;
  margin-top: 20px;
}
</style>
